module.exports = __webpack_public_path__ + "img/studentCenter.1b820c0d.svg";